module.exports = __webpack_public_path__ + "static/media/7.d13eecd8.jpg";